import React from 'react';

const NeonText = ({ children, color = '#00FFD1', className = '' }) => {
  return (
    <span 
      className={`relative ${className}`}
      style={{
        color: color,
        textShadow: `
          0 0 10px ${color}80,
          0 0 20px ${color}60,
          0 0 30px ${color}40,
          0 0 40px ${color}20
        `
      }}
    >
      {children}
    </span>
  );
};

export default NeonText;